// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3750e73e","162":"235677b8","171":"8f140561","453":"34b8c30b","649":"ebd3db9a","747":"8e1e18a1"}[chunkId] + ".chunk.js";
};